/**
 * @author Cristyan Ballesteros
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IDocumentosUsuarios from './entidades/documentosUsuarios';
import IDocumentosUsuariosCompuesto from './entidades/documentosUsuariosCompuesto';
import IPaginadorConsultasDocumentosUsuarios from './entidades/paginadorConsultasDocumentosUsuarios';

export default class ModeloGestionOperadores {
    public consultarListaDocumentosUsuarios() {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.get('GestionOperadores/ConsultarListaDocumentosUsuarios'),
            true
        );
    }

    public consultarDocumentosUsuariosLlave(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.post('GestionOperadores/ConsultarDocumentosUsuariosLlave', documentosusuarios),
            true
        );
    }

    public guardarDocumentosUsuarios(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.post('GestionOperadores/GuardarDocumentosUsuarios', documentosusuarios),
            true
        );
    }

    public editarDocumentosUsuarios(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.put('GestionOperadores/EditarDocumentosUsuarios', documentosusuarios),
            true
        );
    }

    public eliminarDocumentosUsuarios(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.delete('GestionOperadores/EliminarDocumentosUsuarios', documentosusuarios),
            true
        );
    }

    public consultarListaDocumentosUsuariosPorFiltro(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuesta<IDocumentosUsuarios>>(
            () => negocio.post('GestionOperadores/ConsultarListaDocumentosUsuariosPorFiltro', documentosusuarios),
            true
        );
    }

    public consultarDocumentosCompuestosPaginadaFiltro(filtro: IPaginadorConsultasDocumentosUsuarios) {
        return manejadorRest<IRespuestaPaginada<IDocumentosUsuariosCompuesto>>(
            () => negocio.post('GestionOperadores/ConsultarDocumentosCompuestosPaginadaFiltro', filtro),
            true
        );
    }

    public editarListaDocumentosUsuarios(documentosusuarios: IDocumentosUsuarios) {
        return manejadorRest<IRespuestaPaginada<IDocumentosUsuarios>>(
            () => negocio.put('GestionOperadores/EditarListaDocumentosUsuarios', documentosusuarios),
            true
        );
    }
}
